<div mat-dialog-title class="title">
    <span class="heading">{{clientOffice}} Expected Funds</span>
    <button (click)="closeDialog()" mat-dialog-close class="close-button" mat-icon-button matSuffix>
        <mat-icon class="close-icon-color">cancel</mat-icon>
    </button>
</div>
<div class="wrapper">
    <div class="form-container">
        <form [formGroup]="ExpectFundForm" class="form">
            <mat-form-field class="fullLength" *ngIf="showReturnReason">
                <mat-label style="color: red;">Rejected Reason</mat-label>
                <input matInput formControlName="returnReason" readonly>
            </mat-form-field>
            <mat-form-field class="fullLength">
                <mat-label>Payment method</mat-label>
                <mat-select formControlName="paymentMethod" (selectionChange)="onPaymentMethodChange()">
                    <mat-option *ngFor="let method of paymentMethodDropdown"
                                [value]="method">
                        {{method}}
                    </mat-option>
                </mat-select>
                <mat-error *ngIf="ExpectFundForm.get('paymentMethod')?.invalid">Please select a valid payment method.</mat-error>
            </mat-form-field>

            @if (selectedPaymentMethod && isPaymentMethodFieldsVisible){
            <div class="payment-details">
                @if (selectedPaymentMethod === 'Electronic funds transfer'){
                <fieldset>
                    <legend>Electronic Funds Transfer</legend>
                    @if (ExpectFundForm.get('receiptType')?.value) {
                    <mat-form-field class="full-width">
                        <mat-label>Receipt Type</mat-label>
                        <input matInput formControlName="receiptType" readonly>
                    </mat-form-field>
                    }
                    <mat-form-field class="full-width">
                        <mat-label>Transaction reference</mat-label>
                        <input matInput formControlName="transactionReference">
                    </mat-form-field>
                </fieldset>
                }

                @if (selectedPaymentMethod === 'Cheque'){
                <fieldset>
                    <legend>Cheque</legend>
                    <mat-form-field class="full-width">
                        <mat-label>Date</mat-label>
                        <input matInput [matDatepicker]="picker" formControlName="checkDate">
                        <mat-datepicker-toggle matSuffix color="mat-accent"
                                               [for]="picker"></mat-datepicker-toggle>
                        <mat-datepicker #picker></mat-datepicker>
                    </mat-form-field>

                    <mat-form-field class="full-width">
                        <mat-label>From</mat-label>
                        <input matInput formControlName="checkFrom">
                    </mat-form-field>

                    <mat-form-field class="full-width">
                        <mat-label>Number</mat-label>
                        <input matInput formControlName="checkNumber">
                    </mat-form-field>

                    <mat-form-field class="full-width">
                        <mat-label>Memo</mat-label>
                        <input matInput formControlName="checkMemo">
                    </mat-form-field>

                    <mat-form-field class="full-width">
                        <mat-label>Bank name</mat-label>
                        <input matInput formControlName="checkBankName">
                    </mat-form-field>

                    <mat-form-field class="full-width">
                        <mat-label>Bank branch</mat-label>
                        <input matInput formControlName="checkBankBranch">
                    </mat-form-field>

                    <mat-form-field class="full-width">
                        <mat-label>Transaction reference</mat-label>
                        <input matInput formControlName="transactionReference">
                    </mat-form-field>
                </fieldset>
                }

                @if (selectedPaymentMethod === 'Credit Card'){
                <fieldset>
                    <legend>Credit Card</legend>
                    <mat-form-field class="full-width">
                        <mat-label>Last four numbers</mat-label>
                        <input matInput formControlName="lastFourNumbers" type="text" maxlength="4">
                    </mat-form-field>

                    <mat-form-field class="full-width">
                        <mat-label>Authorization number</mat-label>
                        <input matInput formControlName="authorizationNumber" type="text">
                    </mat-form-field>
                </fieldset>
                }
            </div>
            }

            <div class="fullLength">
                <mat-form-field class="matterAuto">
                    <mat-label>Matter</mat-label>
                    <button *ngIf="ExpectFundForm.get('matter')?.value" (click)="clearSearchFilter()" mat-icon-button matSuffix [disabled]="isDisabled">
                        <mat-icon>clear</mat-icon>
                    </button>
                    <input matInput
                           formControlName="matter"
                           [matAutocomplete]="auto" />
                    <mat-error>Please select a matter.</mat-error>
                </mat-form-field>
                <mat-autocomplete #auto="matAutocomplete">
                    <mat-option *ngIf="isLoading">
                        Loading....
                    </mat-option>
                    <mat-option *ngIf="noData && !isLoading">
                        No matching matters found.
                    </mat-option>
                    <div *ngIf="!isLoading && !noData">
                        <mat-option *ngFor="let item of matterDropdownData"
                                    [value]="displayMatter(item)"
                                    (onSelectionChange)="lookupSelecttionChangd($event)">
                            {{ item.number }} - {{ item.description }}
                        </mat-option>
                    </div>
                </mat-autocomplete>
            </div>

            @if (showLinkToOpenMatter()) {
            <div class="sticky-actionstep-bar">
                <div class="link-wrapper">
                    <a [href]="actionstepMatterUrl"
                       target="_blank"
                       rel="noopener noreferrer">
                        Open Matter in Actionstep ({{ matterNo }})
                    </a>
                    <button type="button" mat-icon-button
                            class="small-copy-btn"
                            [cdkCopyToClipboard]="actionstepMatterUrl"
                            (cdkCopyToClipboardCopied)="onUrlCopied()"
                            matTooltip="Copy link to clipboard"
                            matTooltipPosition="below">
                        <mat-icon>content_copy</mat-icon>
                    </button>
                </div>
                <div class="warning-box">
                    You must be logged into Actionstep under the same jurisdiction.
                </div>
            </div>
            }

            <mat-form-field [ngClass]="{ 'fullLength': !showDateTransaction() }">
                <mat-label>Client Name</mat-label>
                <input matInput formControlName="clientName" readonly />
                <mat-progress-spinner *ngIf="isLoading"
                                      class="spinner-padding"
                                      matSuffix
                                      mode="indeterminate"
                                      diameter="20"
                                      strokeWidth="3"
                                      color="accent">
                </mat-progress-spinner>
            </mat-form-field>

            @if(showDateTransaction()){
                <div class="date-time-row">
                    <mat-form-field color="accent" class="date-field">
                        <mat-label>Transaction Date</mat-label>
                        <input matInput [matDatepicker]="transactionDatePicker" formControlName="dateTransaction" />
                        <mat-datepicker-toggle matSuffix [for]="transactionDatePicker" />
                        <mat-datepicker #transactionDatePicker />
                        @if (ExpectFundForm.get('dateTransaction')?.touched && ExpectFundForm.get('dateTransaction')?.invalid) {
                        <mat-error>Please select a date.</mat-error>
                        }
                    </mat-form-field>

                    <mat-form-field color="accent" class="time-field">
                        <mat-label>Transaction Time</mat-label>
                        <input matInput
                               type="time"
                               formControlName="transactionTime" />
                    </mat-form-field>
                </div>
            }

            <mat-form-field class="fullLength">
                <mat-label>Reason for expected funds</mat-label>
                <input matInput formControlName="reason" />
            </mat-form-field>

            <div class="date-time-row">
                <mat-form-field color="accent" class="date-field">
                    <mat-label>Requested Date</mat-label>
                    <input matInput [matDatepicker]="requestedDatePicker" formControlName="dateRequested" placeholder="dd/MM/yyyy" [max]="currentDate"/>
                    <mat-datepicker-toggle matSuffix [for]="requestedDatePicker" />
                    <mat-datepicker #requestedDatePicker />
                    @if (ExpectFundForm.get('dateRequested')?.touched && ExpectFundForm.get('dateRequested')?.invalid) {
                    <mat-error>Please select a date.</mat-error>
                    }
                </mat-form-field>

                <mat-form-field color="accent" class="time-field">
                    <mat-label>Requested Time</mat-label>
                    <input matInput type="time" formControlName="requestedTime" placeholder="HH:mm" />
                    @if (ExpectFundForm.get('requestedTime')?.touched && ExpectFundForm.get('requestedTime')?.invalid) {
                    <mat-error>Please enter a time.</mat-error>
                    }
                </mat-form-field>
            </div>

            <mat-form-field>
                <mat-label>Expected amount to be received</mat-label>
                <input matInput maxlength="12" step="0.01" formControlName="expValPayment" (keydown)="validateInput($event)" [value]="displayValue" (blur)="formatNumber()" appCurrencyInput />
                <mat-error *ngIf="ExpectFundForm.get('expValPayment')?.invalid">Please enter a valid amount.</mat-error>
            </mat-form-field>
            <mat-form-field>
                <mat-label>Client Bank</mat-label>
                <mat-select formControlName="clientBankAccount">
                    <mat-option *ngFor="let account of filteredBankAccounts" [value]="account">
                        {{ account.accountId }} - {{ account.description }}
                    </mat-option>
                </mat-select>
            </mat-form-field>

            @if (showLinkToOpenMatter()) {
            <div class="actionstep-matter-overview">
                <div class="link-wrapper">
                    <a [href]="actionstepMatterOverviewUrl"
                       target="_blank"
                       rel="noopener noreferrer">
                        Open Actionstep Matter ({{ matterNo }}) Overview
                    </a>
                    <button type="button" mat-icon-button
                            class="small-copy-btn"
                            [cdkCopyToClipboard]="actionstepMatterOverviewUrl"
                            (cdkCopyToClipboardCopied)="onUrlCopied()"
                            matTooltip="Copy link to clipboard"
                            matTooltipPosition="below">
                        <mat-icon>content_copy</mat-icon>
                    </button>
                </div>
                <div class="warning-box">
                    You must be logged into Actionstep under the same jurisdiction.
                </div>
            </div>
            }
            <mat-form-field class="fullLength">
                <mat-label>Notes to accounts</mat-label>
                <textarea matInput class="checkbox-text" formControlName="notesToAccounts"></textarea>
            </mat-form-field>

            <mat-form-field class="fullLength">
                <mat-label>Are monies coming from client?</mat-label>
                <mat-select formControlName="moniesCheckbox">
                    <mat-option [value]="true">Yes</mat-option>
                    <mat-option [value]="false">No</mat-option>
                </mat-select>
            </mat-form-field>

            @if (showPayeeSelect) {
            <mat-form-field class="fullLength">
                <mat-label>Received from</mat-label>
                <mat-select multiple required panelClass="sw-multi-select-panel" [formControl]="payeeClients"
                            [errorStateMatcher]="payeeErrorMatcher"
                            (selectionChange)="onPayeeClientsChange()"
                            (openedChange)="onPayeeSelectOpened($event)">
                    @for (name of clientOptions; track name) {
                    <mat-option [value]="name">{{ name }}</mat-option>
                    }
                </mat-select>
                <mat-error>Please select at least one payee.</mat-error>
            </mat-form-field>
            } @else {
            <mat-form-field class="fullLength">
                <mat-label>Received from</mat-label>
                <input matInput formControlName="payer" />
                <mat-progress-spinner *ngIf="isLoading"
                                      class="spinner-padding"
                                      matSuffix
                                      mode="indeterminate"
                                      diameter="20"
                                      strokeWidth="3"
                                      color="accent">
                </mat-progress-spinner>
                <mat-error *ngIf="ExpectFundForm.get('payer')?.invalid">Please enter recieved from.</mat-error>
            </mat-form-field>
            }

            <div class="fullLength">
                <mat-form-field>
                    <mat-label>Partner authorising</mat-label>
                    <input readonly matInput formControlName="partnerAuthorising" />
                </mat-form-field>
            </div>

            <mat-form-field class="fullLength">
                <mat-label>Files to upload</mat-label>
                <input matInput [value]="displayFile.join(', ')" placeholder="Please select a file" readonly [disabled]="isDisabled">
                <button (click)="fileInput.click()" mat-icon-button matSuffix [disabled]="isDisabled">
                    <mat-icon>upload_file</mat-icon>
                </button>
                <button *ngIf="displayFile.length > 0" (click)="clearUpload(fileInput)" mat-icon-button matSuffix>
                    <mat-icon>clear</mat-icon>
                </button>
                <input type="file" id="fileInput" (change)="onFilesSelected($event.target)" #fileInput multiple hidden>
            </mat-form-field>
        </form>
    </div>
</div>

<div class="action-button" mat-dialog-actions>
    <button mat-raised-button color="accent" type="submit" (click)="delete()" [disabled]="isRejectDisabled">
        Reject
    </button>
    <button mat-raised-button color="accent" type="submit" (click)="withdrawReceipt()" [disabled]="isWithdrawDisabled">
        Withdraw Expected fund
    </button>
    <button mat-raised-button color="accent" type="submit" (click)="approveRequest()" [disabled]="isDisabled || ExpectFundForm.invalid">
        Submit
    </button>
</div>
